import React, { useEffect, useRef } from 'react';

import styled from 'styled-components';

import { useActiveWeb3React } from '../../hooks';
import Jazzicon from 'jazzicon';
import { AddressZero } from '@ethersproject/constants';

const StyledIdenticonContainer = styled.div`
  height: 1rem;
  width: 1rem;
  border-radius: 1.125rem;
  @media (max-width: 900px) {
    width: 12px !important;
    height: 10px !important;
    & > * {
      display: block !important;
      margin-top: -10px;
      width: 10px !important;
      height: 10px !important;
    }
  }
`;

export default function Identicon() {
  const ref = useRef<HTMLDivElement>();
  const { account } = useActiveWeb3React();

  useEffect(() => {
    if (ref.current) {
      const target = parseInt((account ?? AddressZero).slice(2, 10), 18);
      ref.current.innerHTML = '';
      ref.current.appendChild(Jazzicon(18, target));
    }
  }, [account]);

  // https://github.com/DefinitelyTyped/DefinitelyTyped/issues/30451
  return <StyledIdenticonContainer ref={ref as any} />;
}
